import { VStack } from '@chakra-ui/react'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AddressSearch } from '@/components/atoms/Form/AddressSearch/AddressSearch'
import { MapProvider } from '@/components/atoms/Form/MapContext'

import { CircleWizardFormData } from '../types'

export const LocationStep = () => {
  const { t } = useTranslation()
  const { setValue } = useFormContext<CircleWizardFormData>()

  return (
    <VStack gap={6} width="1/2">
      <MapProvider>
        <AddressSearch
          key={`circle-address-search-location`}
          placeholder={t('communities.form.address.placeholder')}
          onAddressChanged={(event) => {
            const { coordinates, address, city } = event
            if (!coordinates?.lat || !coordinates?.lng) {
              throw new Error('coordinates are required')
            }
            setValue('address', address || '')
            setValue('city', city || '')
            setValue('latitude', `${coordinates.lat}`)
            setValue('longitude', `${coordinates.lng}`)
            setValue('explicitLocationLabel', address || '')
          }}
          defaultValue={{
            address: null,
            latitude: null,
            longitude: null,
          }}
          mode="light"
        />
      </MapProvider>
    </VStack>
  )
}
